
import Vue from "vue";
import * as types from "@/store/mutation-types";
import { FormBlock } from "@/components/FormBuilder/types";
import { objectDifference } from "@/helpers";
import { watercraftTypeFormSchema } from "@/forms/admin/watercraftType";
import {
  watercraftTypeMapActions,
  watercraftTypeMapGetters,
  watercraftTypeMapMutations,
  watercraftTypeMapState
} from "@/store/modules/watercraftType";

export default Vue.extend({
  name: "UpdateWatercraftTypeView",
  data() {
    return {
      resourceNotFound: false,
      errorMessage: "",
      isLoading: false,
      successMessage: "",
      loadingText: ""
    };
  },
  created() {
    this.getWatercraftType(this.watercraftTypeId)
      .then(data => {
        this.SET_EDIT(data);
      })
      .catch(error => {
        this.resourceNotFound = true;
        this.$bugSnagClient.notify(error);
      });
  },
  destroyed() {
    this.SET_EDIT(" " as any);
  },
  methods: {
    ...watercraftTypeMapActions(["getWatercraftType", "updateWatercraftType"]),
    ...watercraftTypeMapMutations(["SET_EDIT"]),
    ...watercraftTypeMapMutations({ editField: types.SET_EDIT_FIELD }),
    formFieldChangeHandler({ key, value }: { key: any; value: any }) {
      this.editField({ key, value });
    },
    onToolbarItemClick(event: string) {
      switch (event) {
        case "cancelEditWatercraftType":
          this.watercraftTypesCallback();
          break;
        case "update":
          this.updateCallback();
          break;
      }
    },
    async watercraftTypesCallback(): Promise<any> {
      this.$router.push("/admin/watercraftTypes").catch(() => {});
    },
    async updateCallback(): Promise<void> {
      try {
        this.isLoading = true;
        this.loadingText = "Updating watercraft type. Please wait...";
        await this.updateWatercraftType({
          id: this.watercraftTypeId,
          update: this.updatedFields
        });
        this.$appNotifySuccess("Watercraft Type Updated Successfully");
        this.watercraftTypesCallback();
      } catch (error) {
        this.errorMessage = error.message;
        this.$bugSnagClient.notify(error);
      } finally {
        this.isLoading = false;
        this.loadingText = "";
      }
    }
  },
  computed: {
    ...watercraftTypeMapGetters([
      "getWatercraftTypeById",
      "editingWatercraftType"
    ]),
    ...watercraftTypeMapState(["makingApiRequest", "editing"]),
    watercraftTypeId(): string {
      return this.$route.params.watercraftTypeId;
    },
    watercraftType(): any {
      return this.getWatercraftTypeById(this.watercraftTypeId);
    },
    updatedFields(): any {
      const edited = this.editingWatercraftType;
      const original = this.watercraftType;
      return edited && original ? objectDifference(edited, original) : {};
    },
    watercraftTypeFields(): FormBlock[] {
      return watercraftTypeFormSchema;
    }
  }
});
